import React, { Component } from 'react';
interface State {
  hasError: boolean;
}
interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}
export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(): State {
    return {
      hasError: true
    };
  }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? <div className="min-h-screen flex items-center justify-center bg-white px-6" data-id="element-63">
            <div className="text-center max-w-md" data-id="element-64">
              <h1 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-65">
                Algo salió mal
              </h1>
              <p className="text-sm text-gray-500 mb-6" data-id="element-66">
                Recarga la página para volver a intentarlo.
              </p>
              <button onClick={() => window.location.reload()} className="py-2.5 px-5 rounded-xl text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 transition-colors" data-id="element-67">
                Recargar
              </button>
            </div>
          </div>;
    }
    return this.props.children;
  }
}